import useWindowDimensions from '../../../../r/shared/custom-hooks/useWindowDimension';

const useModalConfig = (config = {}) => {
	const { width } = useWindowDimensions();
  let styles = { ...config };

  const viewports = {
    md: width >= 768 && width <= 1024,
    lg: width > 1024,
    sm: width < 768
  };
  
  const viewport = Object.keys(viewports).find((key) => viewports[key]);
  
  if (typeof styles?.maxWidth === 'object') {
    styles.maxWidth = styles.maxWidth[viewport];
  }

  return { viewport, styles };
};

export default useModalConfig;